import { Container } from '@acies/core';
import theme from './theme';

export default class StrokeContainer extends Container {
	public constructor() {
		super();
		this.stroke = theme.strokes.soft;
		this.fill = theme.colors.fill.white;
		this.paddingHorizontal = 16;
		this.paddingVertical = 16;
		this.cornerRadius = 16;
		this.autoLayout = 'vertical';
	}
}
customElements.define('ac-stroke-container', StrokeContainer);
